import React, { Component, useState, useRef,useEffect } from "react";

import {
    PdfLoader,
    PdfHighlighter,
    Tip,
    Highlight,
    Popup,
    AreaHighlight, IHighlight, NewHighlight
} from "react-pdf-highlighter";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import HighlightPopup from './components/HighlightPopup.jsx';
import Highlighter from './components/Highlighter.jsx';
import OverviewScrollbar from "./components/OverviewScrollbar.jsx";
import { Scrollbars } from 'react-custom-scrollbars-2';
import AddCommentPrompt from "./components/AddCommentPrompt.jsx";
import "./customMedboardPdf.css";


const convertSavedComments = (savedComments, setCustomHighlights) => {
    var converted = [];
    for (let index = 0; index < savedComments.length; index++) {
        const savedComment = savedComments[index];
        converted.push(convertSavedComment(savedComment,setCustomHighlights));
    }
    return converted;

};

const convertSavedComment = (savedComment,setCustomHighlights) => {

    var highlight = {
        content: {

        },
        position: JSON.parse(savedComment.Position),
        comment: {
            text: savedComment.Text,
            colour: savedComment.Colour,
            author: savedComment.Author,
            created: savedComment.Created,
            deletable: savedComment.Deletable
        },
        delete: function () {
            fetch("/umbraco/api/documentcomment/DeleteComment?id="+savedComment.Id, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
               
            })
                .then((response) => {
                    if (!response.ok) {
                        if (response.status === 401)
                            document.dispatchEvent(new Event("api:unauthorized"));

                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((data) => {

                    data = data.map(item => item.Result);

                    var model = convertSavedComments(data,setCustomHighlights);
                    setCustomHighlights(model);
                })
                .catch((error) => {
                    // Handle any errors that occurred during the fetch
                    console.log("error: " + error);
                })
                .finally(() => {

                });
        },
        type: "_custom_"
    };
    var model = { ...highlight, id: "custom_" + savedComment.Id, type: "_custom_" };
    return model;
};


const resetHash = () => {
};


const MedboardPdfDisplayer = ({ pdfDocument, currentHighlights, updater, surveilanceItem, surveilanceId, savedComments, customKeywordHighlights, showHighlightsButton = true, showAnnotationsButton = true, scrollRef }) => {
    //console.log("SavedCOmments", savedComments);
    const [container, setContainer] = useState();
    const queryRef = useRef(undefined);
    const [searchState, setSearchState] = useState();
    const [currentSearchItem, setcurrentSearchItem] = useState();
    const [countOfResults, setCountOfResults] = useState();
    const [searchResultLocations, setSearchResultLocations] = useState({ matches: [], lengths: [] });
    const [customHighlights, setCustomHighlights] = useState([]);

    const pdfDoSearch = useRef((query) => { console.log("DEFAULT SEARCH HANDLER.", query); });
    const pdfKeywordSearch = useRef((query) => { console.log("DEFAULT pdfKeywordSearch HANDLER.", query); });

    const [showAIHighlights, setShowAIHighlights] = useState(true);
    const [showCustomHighlights, setShowCustomHighlights] = useState(true);

    //const scrollRef = useRef(null);


    //const handleShowCustomKeywordHighlighting = (show) => {
    //    /* if(show){
    //            pdfKeywordSearch.current(customKeywordHighlights.inclusionKeywords);
    //        }else{
    //            pdfKeywordSearch.current([]);
    //        }*/
    //}


    //const handleScrollto = (id) => {
    //    var selectedHighlight = myStateRef.current.find((highlight) => highlight.id === id);
    //    scrollViewerTo(selectedHighlight);
    //}



    const handleGoToCitation = (citation) => {

        //console.log("going to scroll to page " + citation.Page);

        if (!scrollRef.current) return;

        // usePdfCoordinates: true so PDF bottom-left y0/y1 are converted correctly.
        // Without it, y0 (bottom of the box) is treated as viewport "top" and the
        // viewer scrolls to the end of the highlight instead of the start.
        scrollRef.current({
            position: {
                pageNumber: citation.Page,
                usePdfCoordinates: true,
                boundingRect: { x1: citation.x0, y1: citation.y0, x2: citation.x1, y2: citation.y1, width: citation.PageWidth, height: citation.PageHeight },
            },
            content: { text: "" },
            id: "jump-" + citation.Page,
        });
    }






    useEffect(() => {
        setCustomHighlights(convertSavedComments(savedComments, setCustomHighlights));

        //updater.on("showCustomKeywordHighlighting", handleShowCustomKeywordHighlighting);
        //updater.on("scrollto", handleScrollto);
        //updater.on("goToCitation", handleGoToCitation);

        return () => {

            //updater.off("showCustomKeywordHighlighting", handleShowCustomKeywordHighlighting);
            //updater.off("scrollto", handleScrollto);
            //updater.off("goToCitation", handleGoToCitation);
        }


    }, []);

    

    //let scrollViewerTo = (highlight) => { };

    const _search = (e) => {
        e.preventDefault();/*(query: string, isAgain: boolean, isPrevious: boolean)/*/
        pdfDoSearch.current(queryRef.current.value, false, false);
    }
    const _searchNext = (e) => {
        e.preventDefault();
        pdfDoSearch.current(queryRef.current.value, true, false);
    }
    const _searchPrev = (e) => {
        e.preventDefault();
        pdfDoSearch.current(queryRef.current.value, true, true);
    }
    //console.log("currentHighlights", currentHighlights);
    var mergedHighlights = [];



    if (showAIHighlights)
        mergedHighlights = [...mergedHighlights, ...currentHighlights];

    if (showCustomHighlights)
        mergedHighlights = [...mergedHighlights, ...customHighlights];



    


    //console.log("highlights", mergedHighlights);
    var inner = null;
    if (container) {
        inner = <PdfHighlighter
                    pdfDocument={pdfDocument}
                    scrollRef={(scrollTo) => {
                        //scrollViewerTo = scrollTo;
                        scrollRef.current = scrollTo;
                    }}
                    pdfDoSearchRef={(search) => {
                        pdfDoSearch.current = search;
                    }}
                    pdfTermSearchRef={(search) => {
                        pdfKeywordSearch.current = search;
                    }}
                    containerRef={container}
                    onScrollChange={resetHash}
                    onSelectionFinished={(
                        position,
                        content,
                        hideTipAndSelection,
                        transformSelection
                        ) => {
                            hideTipAndSelection();

                            // If custom annotations aren't enabled don't show "Add annotation" popup button
                            if (!showCustomHighlights || !showAnnotationsButton)
                                return;

                            return (
                                <AddCommentPrompt
                                    onOpen={transformSelection}
                                    onConfirm={(comment) => {
                                        // this.addCustomHighlight();
                                        var highlight = { content, position, comment, type: "_custom_" };
                                        fetch("/umbraco/api/documentcomment/SaveComment", {
                                            method: "POST",
                                            headers: { "Content-Type": "application/json" },
                                            body: JSON.stringify({
                                                text: comment.text,
                                                colour: comment.colourcode,
                                                position: JSON.stringify(position),
                                                surveilanceItem: surveilanceId,
                                                surveilanceId: surveilanceItem
                                            })
                                        })
                                            .then((response) => {
                                                if (!response.ok) {
                                                    if (response.status === 401)
                                                        document.dispatchEvent(new Event("api:unauthorized"));

                                                    throw new Error("Network response was not ok");
                                                }
                                                return response.json();
                                            })
                                            .then((data) => {
                                                var model = [convertSavedComment(data,setCustomHighlights), ...customHighlights];
                                                setCustomHighlights(model);
                                            })
                                            .catch((error) => {
                                                // Handle any errors that occurred during the fetch
                                                console.log("error: " + error);
                                            })
                                            .finally(() => {

                                            });

                                        hideTipAndSelection();
                                    }}
                                />
                            )
                        }}

                    highlightTransform={(
                        highlight,
                        index,
                        setTip,
                        hideTip,
                        viewportToScaled,
                        screenshot,
                        isScrolledTo
                    ) => {
                        const component = <Highlighter
                            isScrolledTo={isScrolledTo}
                            position={highlight.position}
                            comment={highlight.comment}
                        />;
                        return (
                            <Popup
                                popupContent={<HighlightPopup id={highlight.id} {...highlight} />}
                                onMouseOver={(popupContent) =>
                                    setTip(highlight, (highlight) => popupContent)
                                }
                                onMouseOut={hideTip}
                                key={index}
                                children={component}
                            />
                        );
                    }}
                    highlights={mergedHighlights}
                    updateFindCount={(e) => {
                        //console.log("updateFindCount", e);
                        setCountOfResults(e.matchesCount.total);
                        setcurrentSearchItem(e.matchesCount.current);
                        //setSearchResultLocations({matches: e.source.pageMatches, lengths: e.source.pageMatchesLength});
                        //window.tescount = e;

                    }}
                    updateFindControlState={(e) => {
                        //console.log("updateFindControlState", e);
                        setSearchState(e.state);
                        setCountOfResults(e.matchesCount.total);
                        setcurrentSearchItem(e.matchesCount.current);
                        // setSearchResultLocations({matches: e.source.pageMatches, lengths: e.source.pageMatchesLength});
                        // window.tesstate = e;
                    }}
                />;
    }
    return <>
        <nav className="navbar navbar-light bg-light">
            <form onSubmit={_search} className="form-inline">

                <div>
                    <input className={"form-control mr-sm-2 " + (searchState == 1 ? "error" : "")} type="search" placeholder="Search" aria-label="Search" ref={queryRef} />

                    {searchState == 3 && (
                        <button className="btn btn-outline-dark my-2 my-sm-0" type="button" disabled><i className="fas fa-search"></i> Searching</button>
                    )}
                    {searchState != 3 && (
                        <button className="btn btn-outline-dark my-2 my-sm-0" type="button" onClick={_search}><i className="fas fa-search"></i> Search</button>
                    )}
                </div>

                {countOfResults > 0 ? <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginLeft: "10px" }}>

                    <span style={{ marginRight: "10px", display: "flex", alignItems: "center" }}>Results: {countOfResults > 0 ? currentSearchItem + " / " + countOfResults : "0"}</span>

                    <span style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ cursor: "pointer", marginRight: "5px", border: "1px solid #888", textAlign: "center", width: "30px", padding: "4px", border: "1px solid #c0c0c0", borderRadius: "4px" }} onClick={_searchPrev}>
                            <i className="fa fa-chevron-up" aria-hidden="true"></i>
                        </div>
                        <div style={{ cursor: "pointer", border: "1px solid #888", textAlign: "center", width: "30px", padding: "4px", border: "1px solid #c0c0c0", borderRadius: "4px" }} onClick={_searchNext}>
                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        </div>
                    </span>
                </div> : <>

                </>}


                {/*showHighlightsButton ? 
                    <div style={{ marginLeft: "20px" }}>
                        <div onClick={() => setShowAIHighlights(!showAIHighlights)} style={{ cursor: "pointer", marginRight: "5px", border: "1px solid #888", textAlign: "center", width: "30px", padding: "4px", border: "1px solid #c0c0c0", borderRadius: "4px", background: showAIHighlights ? "#daffde" : "#fff", }}
                            className="instantTooltip"
                            aria-label={showAIHighlights ? "AI Highlights enabled" : "AI Highlights disabled"}>
                            <i className="far fa-comment-alt"></i>
                        </div>
                    </div>
                    : null
                */}

                {showAnnotationsButton ? 
                    <div style={{ marginLeft: "6px" }}>
                        <div onClick={() => setShowCustomHighlights(!showCustomHighlights)}
                            style={{ cursor: "pointer", marginRight: "5px", border: "1px solid #888", textAlign: "center", width: "30px", padding: "4px", border: "1px solid #c0c0c0", borderRadius: "4px", background: showCustomHighlights ? "#daffde" : "#fff", }}
                            className="instantTooltip"
                            aria-label={showCustomHighlights ? "Annotations enabled - To add an annotation first select some text and then click on the 'Add annotation' button." : "Annotations disabled - Click to activate"}>

                            <i className="far fa-comment-alt"></i>
                        </div>
                    </div>
                    : null
                }


            </form>
        </nav>

        <OverviewScrollbar
            pdfDocument={pdfDocument}
            highlights={mergedHighlights}
            searchResults={searchResultLocations}
            containerRefSetter={c => { if (!container && c) { setContainer(c) } }}
        >
            {inner}
        </OverviewScrollbar>
    </>
};


const MedboardPdf = ({ url, updater, surveilanceItem, surveilanceId, savedComments, customKeywordHighlights, showHighlightsButton = true, showAnnotationsButton = true, containerHeight = "67vb" }) => {
    const [currentHighlights, _setCurrentHighlights] = useState([]);
    const [showKeywordHighlighting, setShowKeywordHighlighting] = useState(true);

    const myStateRef = useRef(currentHighlights);
    const scrollRef = useRef(null);

    const setCurrentHighlights = data => {
        myStateRef.current = data;
        _setCurrentHighlights(data);
    };

    // PdfLoader reuses this component across URL changes; drop stale citation highlights.
    useEffect(() => {
        setCurrentHighlights([]);
    }, [url]);


    useEffect(() => {

        const handleHighlights = ({ highlights, appraisalType }) => {

            var isLiterature = appraisalType == "Literature";
            var renderHighlights = [];
            var scrollToCitation = null;

            for (let i = 0; i < highlights.SummaryCaptures?.length; i++) {
                const capture = highlights.SummaryCaptures[i];

                if (capture.Coordinates != null && capture.Coordinates.length > 0) {
                    for (let c = 0; c < capture.Coordinates.length; c++) {
                        var coordinate = capture.Coordinates[c];

                        var id = coordinate.Id;

                        var renderModel = {
                            content: {
                                text: capture.Value,
                            },
                            position: {
                                usePdfCoordinates: true,
                                boundingRect: {
                                    x1: coordinate.x0,
                                    y1: coordinate.PageHeight - coordinate.y0,
                                    x2: coordinate.x1,
                                    y2: coordinate.PageHeight - coordinate.y1,
                                    width: coordinate.PageWidth,
                                    height: coordinate.PageHeight
                                },
                                rects: [
                                    {
                                        x1: coordinate.x0,
                                        y1: coordinate.PageHeight - coordinate.y0,
                                        x2: coordinate.x1,
                                        y2: coordinate.PageHeight - coordinate.y1,
                                        width: coordinate.PageWidth,
                                        height: coordinate.PageHeight
                                    },
                                ],
                                pageNumber: coordinate.Page,
                            },
                            comment: {
                                type: "_summary_",
                                value: capture.Value
                            },
                            id: id,
                        };
                        renderHighlights.push(renderModel);
                    }
                }
            }


            let specialHighlight = highlights.Captures.find(hl => hl.Type == "_comparison_deleted_special_" || hl.Type == "_comparison_inserted_special_");

            // Prefer the first highlight in document reading order (page, then top-of-page),
            // not raw array order — AI citation bboxes are often unordered.
            const isEarlierInDocument = (a, b) => {
                if (a.Page !== b.Page)
                    return a.Page < b.Page;
                // PDF coords are bottom-left origin; larger y = higher on the page.
                const aTop = Math.max(a.y0, a.y1);
                const bTop = Math.max(b.y0, b.y1);
                if (aTop !== bTop)
                    return aTop > bTop;
                return Math.min(a.x0, a.x1) < Math.min(b.x0, b.x1);
            };

            for (let i = 0; i < highlights.Captures?.length; i++) {
                const capture = highlights.Captures[i];
                const isIgnored = appraisalType != "Literature" && (capture.Type == "Number of Patients" || capture.Type == "Number of Studies");
                if (!isIgnored) {
                    if (capture.Coordinates != null && capture.Coordinates.length > 0) {
                        for (let c = 0; c < capture.Coordinates.length; c++) {
                            var coordinate = capture.Coordinates[c];

                            var id = coordinate.Id;

                            const canUseForScroll = !specialHighlight || specialHighlight.Type == capture.Type;
                            if (canUseForScroll && (!scrollToCitation || isEarlierInDocument(coordinate, scrollToCitation)))
                                scrollToCitation = coordinate;

                            var renderModel = {
                                content: {
                                    text: capture.Tokens[0],
                                },
                                position: {
                                    usePdfCoordinates: true,
                                    boundingRect: {
                                        x1: coordinate.x0,
                                        y1: coordinate.PageHeight - coordinate.y0,
                                        x2: coordinate.x1,
                                        y2: coordinate.PageHeight - coordinate.y1,
                                        width: coordinate.PageWidth,
                                        height: coordinate.PageHeight
                                    },
                                    rects: [
                                        {
                                            x1: coordinate.x0,
                                            y1: coordinate.PageHeight - coordinate.y0,
                                            x2: coordinate.x1,
                                            y2: coordinate.PageHeight - coordinate.y1,
                                            width: coordinate.PageWidth,
                                            height: coordinate.PageHeight
                                        },
                                    ],
                                    pageNumber: coordinate.Page,
                                },
                                comment: {
                                    type: capture.Type,
                                    value: capture.Value,
                                    tokens: capture.Tokens
                                },
                                id: id,
                            };
                            renderHighlights.push(renderModel);
                        }
                    }
                }
            }
            setCurrentHighlights(renderHighlights);


            if (scrollToCitation)
                updater.emit("goToCitation", scrollToCitation);

        };

        const handleGoToCitation = (citation) => {

            //console.log("going to scroll to page " + citation.Page);

            if (!scrollRef.current) return;

            // usePdfCoordinates: true so PDF bottom-left y0/y1 are converted correctly.
            // Without it, y0 (bottom of the box) is treated as viewport "top" and the
            // viewer scrolls to the end of the highlight instead of the start.
            scrollRef.current({
                position: {
                    pageNumber: citation.Page,
                    usePdfCoordinates: true,
                    boundingRect: { x1: citation.x0, y1: citation.y0, x2: citation.x1, y2: citation.y1, width: citation.PageWidth, height: citation.PageHeight },
                },
                content: { text: "" },
                id: "jump-" + citation.Page,
            });
        }


        updater.on("sethighlights", handleHighlights);
        updater.on("goToCitation", handleGoToCitation);

        // window.medboardPdfEmitter is for requests coming from the AIChat when integrated in the CM/RM that dont have the window.PDFDisplayRef (available only in the appraisal card)
        if (!window.medboardPdfEmitter)
            window.medboardPdfEmitter = [];

        window.medboardPdfEmitter[window.medboardPdfEmitter.length] = updater;
        //window.medboardPdfEmitter[window.medboardPdfEmitter.length] = updater;

        return () => {
            updater.off("sethighlights", handleHighlights);
            updater.off("goToCitation", handleGoToCitation);

            // Un-registering here (not just the .off() above) matters once more than one
            // MedboardPdf can mount across a single page session — e.g. Submissions Q&A,
            // where switching between items' PDFs, or opening the bulk multi-item chat's own
            // viewer, mounts a second/third instance. Without this, window.medboardPdfEmitter
            // keeps every emitter forever, and AIChat.js's citation-click handler (which reads
            // this array to find "the" PDF viewer) can end up pointed at a long-gone instance
            // with no listeners left — clicking a citation button then silently does nothing.
            if (window.medboardPdfEmitter)
                window.medboardPdfEmitter = window.medboardPdfEmitter.filter((e) => e !== updater);
        };

    }, []);


    /*
    updater.on("sethighlights", ({ highlights, appraisalType }) => {
        var isLiterature = appraisalType == "Literature";
        var renderHighlights = [];


        for (let i = 0; i < highlights.SummaryCaptures?.length; i++) {
            const capture = highlights.SummaryCaptures[i];

            if (capture.Coordinates != null && capture.Coordinates.length > 0) {
                for (let c = 0; c < capture.Coordinates.length; c++) {
                    var coordinate = capture.Coordinates[c];

                    var id = coordinate.Id;

                    var renderModel = {
                        content: {
                            text: capture.Value,
                        },
                        position: {
                            usePdfCoordinates: true,
                            boundingRect: {
                                x1: coordinate.x0,
                                y1: coordinate.PageHeight - coordinate.y0,
                                x2: coordinate.x1,
                                y2: coordinate.PageHeight - coordinate.y1,
                                width: coordinate.PageWidth,
                                height: coordinate.PageHeight
                            },
                            rects: [
                                {
                                    x1: coordinate.x0,
                                    y1: coordinate.PageHeight - coordinate.y0,
                                    x2: coordinate.x1,
                                    y2: coordinate.PageHeight - coordinate.y1,
                                    width: coordinate.PageWidth,
                                    height: coordinate.PageHeight
                                },
                            ],
                            pageNumber: coordinate.Page,
                        },
                        comment: {
                            type: "_summary_",
                            value: capture.Value
                        },
                        id: id,
                    };
                    renderHighlights.push(renderModel);
                }
            }
        }



        for (let i = 0; i < highlights.Captures?.length; i++) {
            const capture = highlights.Captures[i];
            const isIgnored = appraisalType != "Literature" && (capture.Type == "Number of Patients" || capture.Type == "Number of Studies");
            if (!isIgnored) {
                if (capture.Coordinates != null && capture.Coordinates.length > 0) {
                    for (let c = 0; c < capture.Coordinates.length; c++) {
                        var coordinate = capture.Coordinates[c];

                        var id = coordinate.Id;

                        var renderModel = {
                            content: {
                                text: capture.Tokens[0],
                            },
                            position: {
                                usePdfCoordinates: true,
                                boundingRect: {
                                    x1: coordinate.x0,
                                    y1: coordinate.PageHeight - coordinate.y0,
                                    x2: coordinate.x1,
                                    y2: coordinate.PageHeight - coordinate.y1,
                                    width: coordinate.PageWidth,
                                    height: coordinate.PageHeight
                                },
                                rects: [
                                    {
                                        x1: coordinate.x0,
                                        y1: coordinate.PageHeight - coordinate.y0,
                                        x2: coordinate.x1,
                                        y2: coordinate.PageHeight - coordinate.y1,
                                        width: coordinate.PageWidth,
                                        height: coordinate.PageHeight
                                    },
                                ],
                                pageNumber: coordinate.Page,
                            },
                            comment: {
                                type: capture.Type,
                                value: capture.Value,
                                tokens: capture.Tokens
                            },
                            id: id,
                        };
                        renderHighlights.push(renderModel);
                    }
                }
            }
        }
        setCurrentHighlights(renderHighlights);
    });
    */





    const addCustomHighlight = (highlight) => {
        console.log("Saving highlight", highlight);
        //  setCustomHighlights([{ ...highlight, id: getNextId() }, ...customHighlights]) 
    }


    return (
        <div className="pfdcontainer" style={{
            height: containerHeight,
            position: "relative",
        }}>

            <PdfLoader url={url} beforeLoad={<LoadingSpinnerImage />} >
                {(pdfDocument) => {
                    return <MedboardPdfDisplayer showKeywordHighlighting={showKeywordHighlighting} customKeywordHighlights={customKeywordHighlights} savedComments={savedComments} currentHighlights={currentHighlights} pdfDocument={pdfDocument} updater={updater} surveilanceItem={surveilanceItem} surveilanceId={surveilanceId}
                        showHighlightsButton={showHighlightsButton} showAnnotationsButton={showAnnotationsButton} scrollRef={scrollRef}
                    />;
                }}
            </PdfLoader>

        </div>
    );

};



export default MedboardPdf;